import { DomSelectorUtils } from "../libs/utils/DomSelectorUtils";
import { vp } from "../managers/vp";
import { ComponentManager } from "../managers/ComponentManager";
export class Component {
    get jsName() {
        return this._jsName;
    }
    constructor(html) {
        if (typeof html === 'string') {
            const div = document.createElement('div');
            div.innerHTML = html;
            if (div.children.length > 1) {
                logger.error('Component cant handle more html elements. handlebar has 2 roots?');
            }
            this._html = div.children[0];
        }
        else {
            this._html = html;
        }
        this._jsName = ComponentManager.getFirstJsName(this._html);
        if (!this._jsName) {
            logger.error('Html component doesnt have a js identifier for ' + this._html.className);
        }
    }
    getComponent(name, context = null, optional = false) {
        const html = this.getHtml(name, context, optional);
        return html ? vp.components.getByHTML(html) : null;
    }
    getComponentList(name, context = null) {
        const htmlList = this.getHtmlList(name, context);
        const list = [];
        htmlList.forEach((html) => {
            if (html) {
                const component = vp.components.getByHTML(html);
                if (component) {
                    list.push(component);
                }
            }
        });
        return list;
    }
    forEachInnerComponent(name, callback, context = null) {
        const htmlList = this.getHtmlList(name, context);
        htmlList.forEach((html) => {
            if (html) {
                vp.components.getByHTML(html, callback);
            }
        });
    }
    forEachComponent(name, callback, context = null) {
        if (!context) {
            context = this._html;
        }
        const htmlList = DomSelectorUtils.getHtmlList(name, context);
        htmlList.forEach((html) => {
            if (html) {
                vp.components.getByHTML(html, callback);
            }
        });
    }
    getHtml(name, context = null, optional = false) {
        if (!context) {
            context = this._html;
        }
        return DomSelectorUtils.getInnerHtml(name, context, optional);
    }
    getHtmlList(name, context = null) {
        if (!context) {
            context = this._html;
        }
        return DomSelectorUtils.getInnerHtmlList(name, context);
    }
    init(...data) {
    }
    onAllComplete(data) {
    }
    get html() {
        return this._html;
    }
}
